module.exports = __webpack_public_path__ + "media/images/rank/bronze-sm-872b7a9eda7df0f3f8521b217afdaa58.svg";